import React from 'react';
import ConfirmationDialog from './ConfirmationDialog';

const withConfirmationDialog =
  ({ title, message, content, onDialogOpenPropName }) =>
  WrappedComponent => {
    return class WithDeletePopup extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          showPopup: false,
          confirmAction: null,
          cancelAction: null,
        };
      }

      onItemAction = cb => {
        const resultPromise = new Promise(resolve => {
          this.setState({
            showPopup: true,
            confirmAction: async () => {
              const res = await cb();
              resolve(res ?? true);
            },
            closeAction: async () => {
              resolve(false);
            },
          });
        });

        return resultPromise;
      };

      onConfirm = () => {
        this.state.confirmAction();
        this.setState({
          showPopup: false,
        });
      };

      onPopupClose = () => {
        this.state.closeAction();
        this.setState({
          showPopup: false,
        });
      };

      render() {
        return (
          <>
            <WrappedComponent
              {...{ [onDialogOpenPropName]: this.onItemAction }}
              {...this.props}
            />
            <ConfirmationDialog
              open={this.state.showPopup}
              onConfirm={this.onConfirm}
              onClose={this.onPopupClose}
              title={title}
              content={content}
              text={message}
            />
          </>
        );
      }
    };
  };

export default withConfirmationDialog;
